var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 177,
    viewBox: "0 0 232 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 137.723C0 144.351 5.37258 149.723 12 149.723H193.17C195.816 149.723 198.388 150.598 200.486 152.212L212.684 161.594C220.575 167.664 232 162.038 232 152.082V12.1133C232 5.48587 226.627 0.113281 220 0.113281H12C5.37258 0.113281 0 5.48586 0 12.1133V137.723Z",
    fill: "#81AEF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7139 44.3892L197.287 44.3892C200.654 44.3892 203.384 41.6595 203.384 38.2922C203.384 34.925 200.654 32.1953 197.287 32.1953L34.7139 32.1953C31.3466 32.1953 28.6169 34.925 28.6169 38.2922C28.6169 41.6595 31.3466 44.3892 34.7139 44.3892Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7139 80.0352L197.287 80.0352C200.654 80.0352 203.384 77.3055 203.384 73.9382C203.384 70.571 200.654 67.8413 197.287 67.8413L34.7139 67.8413C31.3466 67.8413 28.6169 70.571 28.6169 73.9382C28.6169 77.3055 31.3466 80.0352 34.7139 80.0352Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7139 115.681L197.287 115.681C200.654 115.681 203.384 112.951 203.384 109.584C203.384 106.216 200.654 103.487 197.287 103.487L34.7139 103.487C31.3466 103.487 28.6169 106.216 28.6169 109.584C28.6169 112.951 31.3466 115.681 34.7139 115.681Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/Comment.217d2640.svg";
export { ForwardRef as ReactComponent };